// importing from node-modules
import firebase from "firebase/app";
import "firebase/auth";

// for authenticating our application/project with firebase
export const auth = firebase.initializeApp({
  apiKey: "AIzaSyBbLHG08ROyWgYkbLHJ5QHT5xC0bQP1c_k",
  authDomain: "cryptomania-213ee.firebaseapp.com",
  projectId: "cryptomania-213ee",
  storageBucket: "cryptomania-213ee.appspot.com",
  messagingSenderId: "185527491996",
  appId: "1:185527491996:web:f32a029dc6eff0815f7c59",
}).auth();